import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import ReactDOM from "react-dom";

class Scrollbox extends Component {

    constructor(){
        super()
        this.animateScroll = this.animateScroll.bind(this);
    }

    componentDidUpdate(prevProps){  
        if(prevProps.scrolledTo !== this.props.scrolledTo){
            if(typeof this.props.scrolledTo !== 'undefined' && typeof this.props.id !== 'undefined'){
                this.setState({
                    scrolledTo:this.props.scrolledTo
                })
                this.animateScroll();
            }       
        } 
    }

    animateScroll(){
        const node = ReactDOM.findDOMNode(this);

        const start = node.offsetTop;
        const finsh = this.props.scrolledTo;
        let curr = start;
        let movement = setInterval(()=>{
            if(curr > finsh){
                clearInterval(movement);
                return;
            }else{
                this.refs[this.props.id].scrollTop(curr);
                curr = curr+5;
            }            
        },5)
        
    }

    render(){
        return(
            <Scrollbars style={this.props.style} ref={this.props.id}>
                {this.props.children}
            </Scrollbars>
        )        
    }
}

export default Scrollbox;